import React from "react";
import { Tabs, TabList, Tab, TabIndicator, Center, Tooltip } from "@chakra-ui/react";
import { Icon } from "@chakra-ui/icons";
import { MdSpeed, MdOutlineAccountBalance } from "react-icons/md";
import { FaBarsProgress } from "react-icons/fa6";
import { TbChartFunnel } from "react-icons/tb";
import { PiSigma } from "react-icons/pi";
import HomeTab from "./HomeTab";


const ExecutiveNavigationBar = ({ onHandleTabChange }) => {
    const tabStyle = {
        color: '#73d6c2',
        _selected:
            {
                bg: 'green.100'
            }
    };

    return (
        <Center>
            <Tabs defaultIndex={1} onChange={onHandleTabChange} >
                <TabList>
                    <HomeTab />
                    <Tooltip label="Target Reach Gauge" aria-label="Target Reach Gauge">
                        <Tab sx={tabStyle}>
                            <Icon as={MdSpeed} boxSize={8} />
                        </Tab>
                    </Tooltip>
                    <Tooltip label="Completed Days of intake" aria-label="Completed Days of intake">
                        <Tab sx={tabStyle}>
                            <Icon as={FaBarsProgress} boxSize={8} />
                        </Tab>
                    </Tooltip>
                    <Tooltip label="Sales Funnel" aria-label="Sales Funnel">
                        <Tab sx={tabStyle}>
                            <Icon as={TbChartFunnel} boxSize={8} />
                        </Tab>
                    </Tooltip>
                    <Tooltip label="Lead Stage Breakdown" aria-label="Lead Stage Breakdown">
                        <Tab sx={tabStyle}>
                            <Icon as={PiSigma} boxSize={8} />
                        </Tab>
                    </Tooltip>
                    <Tooltip label="Student Councilors Performance" aria-label="Student Councilors Performance">
                        <Tab sx={tabStyle}>
                            <Icon as={MdOutlineAccountBalance} boxSize={8} />
                        </Tab>
                    </Tooltip>
                </TabList>
                <TabIndicator mt='-1.5px' height='2px' bg='blue.500' borderRadius='1px' />
            </Tabs>
        </Center>
    );
};

export default ExecutiveNavigationBar;